export default "__VITE_ASSET__Bj2RsUgL__"